const Global = () => { }

export default Global;

Global.did = 'unset';
Global.postedDid = false;